/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import Header from 'parts/Header';
import Footer from 'parts/Footer';

import { Services, FullStackAI } from 'json/landingPageData';

import ParticleBackground from '../elements/ParticleBackground';

const Icon = ({ d }) => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d={d} />
  </svg>
);

const ICONS = {
  'Web Development': 'M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19 14.5M19 14.5l-3.5-3.5M19 14.5h-9',
  'AI/ML Solutions': 'M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456z',
  'Mobile Development': 'M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3',
  'UI/UX Design': 'M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42',
  DevOps: 'M5.25 14.25h13.5m-13.5 0a3 3 0 01-3-3m3 3a3 3 0 100 6h13.5a3 3 0 100-6m-16.5-3a3 3 0 013-3h13.5a3 3 0 013 3m-19.5 0a4.5 4.5 0 01.9-2.7L5.737 5.1a3.375 3.375 0 012.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 01.9 2.7m0 0a3 3 0 01-3 3m0 3h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008zm-3 6h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008z',
  'Creative Design': 'M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zM12 11.25a4 4 0 100-8 4 4 0 000 8zm-3 9h6m-6 0v-3h6v3',
};

export class ServicesPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="neon-theme min-h-screen">
        <Header />
        <ParticleBackground />

        {/* Hero */}
        <section className="container mx-auto px-4 lg:px-8 relative z-10">
          <div className="services-hero">
            <h1>
              Comprehensive Engineering <br />
              <span className="neon-text">Services</span>
            </h1>
            <p>
              Scale your business with expert engineering across web, mobile, AI, and cloud.
              High-performance delivery that accelerates digital transformation and ROI.
            </p>
            <div className="hero-cta-wrap mt-8">
              <NavLink to="/contact" className="hero-cta-primary">
                Get Started Today
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </NavLink>
            </div>
          </div>
        </section>

        {/* Our Services */}
        <section className="container mx-auto px-4 lg:px-8 py-16 relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-white">
              Our <span className="neon-text">Services</span>
            </h2>
            <p className="text-blue-100 text-base max-w-2xl mx-auto mt-3">
              End-to-end engineering across product, platform, and delivery.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {Services.map((item) => (
              <div key={item.title} className="service-card-clean">
                <div className="service-card-icon">
                  <Icon d={ICONS[item.title]} />
                </div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Full-Stack AI sub-section */}
        <section className="container mx-auto px-4 lg:px-8 py-16 relative z-10">
          <div className="text-center mb-10">
            <h2 className="text-3xl lg:text-4xl font-bold text-white">
              Full-Stack <span className="neon-text">AI Services</span>
            </h2>
            <p className="text-blue-100 text-base max-w-2xl mx-auto mt-3">
              From data to deployment. We design, build, and operate AI systems end-to-end.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {FullStackAI.map((item) => (
              <div key={item.title} className="ai-card">
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <NavLink to="/contact" className="hero-cta-primary">
              Discuss an AI project
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </NavLink>
          </div>
        </section>

        {/* Office banner */}
        <section className="container mx-auto px-4 lg:px-8 py-12 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div
              className="office-banner"
              style={{ backgroundImage: 'url(/assets/images/office.jpeg)' }}
            >
              <div className="office-banner-content">
                <h2>Our Office</h2>
                <p>
                  A focused, engineering-first space for collaboration, code reviews, and
                  product workshops. We prefer onsite collaboration to move fast and ship
                  quality software.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Closing CTA strip */}
        <section className="container mx-auto px-4 lg:px-8 py-16 relative z-10">
          <div className="max-w-5xl mx-auto services-cta-strip">
            <h2>Ready to Scale Your Technology Infrastructure?</h2>
            <p>Accelerate your growth with a senior-led engineering partner.</p>
            <NavLink to="/contact" className="hero-cta-primary">
              Let&apos;s Talk
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </NavLink>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}

export default ServicesPage;
